import { Chips, ChipsChangeEvent } from 'primereact/chips';
import classes from './CommentsAddEditModal.module.scss';

const CommentsAddEditModal = ({
  value,
  handleValueChange,
}: {
  value: string[];
  handleValueChange: (data: string[] | undefined) => void;
  limitReached?: boolean;
}) => {
  return (
    <div className={classes.addRemoveCommentsModal}>
      <Chips
        value={value}
        onChange={(e: ChipsChangeEvent) => {
          handleValueChange(e.value);
        }}
        style={{ width: '100%' }}
      />
    </div>
  );
};

export default CommentsAddEditModal;
